/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  ApproveTimeEntriesRequest,
  CreateTimeEntryRequest,
  CreateTimeEntryTypeRequest,
  GetPayrollLedgerEntryRequest,
  GetTimeEntryRequest,
  GetTimeEntryResponse,
  GetTimeEntryTypeResponse,
  PaginatedResultOfGetPayrollLedgerEntryResponse,
  PaginatedResultOfGetTimeEntryResponse,
  Result,
  UpdateTimeEntryRequest,
  UpdateTimeEntryTypeRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    ApproveTimeEntriesRequestFromJSON,
    ApproveTimeEntriesRequestToJSON,
    CreateTimeEntryRequestFromJSON,
    CreateTimeEntryRequestToJSON,
    CreateTimeEntryTypeRequestFromJSON,
    CreateTimeEntryTypeRequestToJSON,
    GetPayrollLedgerEntryRequestFromJSON,
    GetPayrollLedgerEntryRequestToJSON,
    GetTimeEntryRequestFromJSON,
    GetTimeEntryRequestToJSON,
    GetTimeEntryResponseFromJSON,
    GetTimeEntryResponseToJSON,
    GetTimeEntryTypeResponseFromJSON,
    GetTimeEntryTypeResponseToJSON,
    PaginatedResultOfGetPayrollLedgerEntryResponseFromJSON,
    PaginatedResultOfGetPayrollLedgerEntryResponseToJSON,
    PaginatedResultOfGetTimeEntryResponseFromJSON,
    PaginatedResultOfGetTimeEntryResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateTimeEntryRequestFromJSON,
    UpdateTimeEntryRequestToJSON,
    UpdateTimeEntryTypeRequestFromJSON,
    UpdateTimeEntryTypeRequestToJSON,
} from '../models/index';

export interface ApiTimeEntriesIdDeleteRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiTimeEntriesIdGetRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiTimeEntriesIdPutRequest {
    id: string;
    updateTimeEntryRequest: UpdateTimeEntryRequest;
    xTenantID?: number;
}

export interface ApiTimeEntriesIdReviewPresenceDeleteRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiTimeEntriesIdReviewPresencePutRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiTimeEntriesPayrollLedgerApproveHoursPostRequest {
    approveTimeEntriesRequest: ApproveTimeEntriesRequest;
    xTenantID?: number;
}

export interface ApiTimeEntriesPayrollLedgerPostRequest {
    getPayrollLedgerEntryRequest: GetPayrollLedgerEntryRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiTimeEntriesPostRequest {
    createTimeEntryRequest: CreateTimeEntryRequest;
    xTenantID?: number;
}

export interface ApiTimeEntriesScrollPostRequest {
    getTimeEntryRequest: GetTimeEntryRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiTimeEntriesTypeIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTimeEntriesTypeIdPutRequest {
    id: number;
    updateTimeEntryTypeRequest: UpdateTimeEntryTypeRequest;
    xTenantID?: number;
}

export interface ApiTimeEntriesTypePostRequest {
    createTimeEntryTypeRequest: CreateTimeEntryTypeRequest;
    xTenantID?: number;
}

export interface ApiTimeEntriesTypesGetRequest {
    xTenantID?: number;
}

/**
 * 
 */
export class TimeClockApi extends runtime.BaseAPI {

    /**
     * Deletes an existing time entry for a user.
     * Delete time entry
     */
    async apiTimeEntriesIdDeleteRaw(requestParameters: ApiTimeEntriesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an existing time entry for a user.
     * Delete time entry
     */
    async apiTimeEntriesIdDelete(requestParameters: ApiTimeEntriesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific time entry by its unique identifier.
     * Get time entry by ID
     */
    async apiTimeEntriesIdGetRaw(requestParameters: ApiTimeEntriesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTimeEntryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTimeEntryResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific time entry by its unique identifier.
     * Get time entry by ID
     */
    async apiTimeEntriesIdGet(requestParameters: ApiTimeEntriesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTimeEntryResponse> {
        const response = await this.apiTimeEntriesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing time entry for a user.
     * Update time entry
     */
    async apiTimeEntriesIdPutRaw(requestParameters: ApiTimeEntriesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesIdPut().'
            );
        }

        if (requestParameters['updateTimeEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTimeEntryRequest',
                'Required parameter "updateTimeEntryRequest" was null or undefined when calling apiTimeEntriesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTimeEntryRequestToJSON(requestParameters['updateTimeEntryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing time entry for a user.
     * Update time entry
     */
    async apiTimeEntriesIdPut(requestParameters: ApiTimeEntriesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Clear time entry review presence
     */
    async apiTimeEntriesIdReviewPresenceDeleteRaw(requestParameters: ApiTimeEntriesIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesIdReviewPresenceDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear time entry review presence
     */
    async apiTimeEntriesIdReviewPresenceDelete(requestParameters: ApiTimeEntriesIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesIdReviewPresenceDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Heartbeat time entry review presence
     */
    async apiTimeEntriesIdReviewPresencePutRaw(requestParameters: ApiTimeEntriesIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesIdReviewPresencePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Heartbeat time entry review presence
     */
    async apiTimeEntriesIdReviewPresencePut(requestParameters: ApiTimeEntriesIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesIdReviewPresencePutRaw(requestParameters, initOverrides);
    }

    /**
     * Approves time entries and moves them to the payroll ledger. The request body should contain the IDs of the time entries to be approved and the name of the approver.
     * Approve time entries for payroll ledger
     */
    async apiTimeEntriesPayrollLedgerApproveHoursPostRaw(requestParameters: ApiTimeEntriesPayrollLedgerApproveHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['approveTimeEntriesRequest'] == null) {
            throw new runtime.RequiredError(
                'approveTimeEntriesRequest',
                'Required parameter "approveTimeEntriesRequest" was null or undefined when calling apiTimeEntriesPayrollLedgerApproveHoursPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/payroll-ledger/approve-hours`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveTimeEntriesRequestToJSON(requestParameters['approveTimeEntriesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approves time entries and moves them to the payroll ledger. The request body should contain the IDs of the time entries to be approved and the name of the approver.
     * Approve time entries for payroll ledger
     */
    async apiTimeEntriesPayrollLedgerApproveHoursPost(requestParameters: ApiTimeEntriesPayrollLedgerApproveHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesPayrollLedgerApproveHoursPostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a paginated list of payroll ledger entries for a specific user. The request body should contain the user ID and optional date range for filtering the entries.
     * Get payroll ledger
     */
    async apiTimeEntriesPayrollLedgerPostRaw(requestParameters: ApiTimeEntriesPayrollLedgerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetPayrollLedgerEntryResponse>> {
        if (requestParameters['getPayrollLedgerEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'getPayrollLedgerEntryRequest',
                'Required parameter "getPayrollLedgerEntryRequest" was null or undefined when calling apiTimeEntriesPayrollLedgerPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/payroll-ledger`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetPayrollLedgerEntryRequestToJSON(requestParameters['getPayrollLedgerEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetPayrollLedgerEntryResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of payroll ledger entries for a specific user. The request body should contain the user ID and optional date range for filtering the entries.
     * Get payroll ledger
     */
    async apiTimeEntriesPayrollLedgerPost(requestParameters: ApiTimeEntriesPayrollLedgerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetPayrollLedgerEntryResponse> {
        const response = await this.apiTimeEntriesPayrollLedgerPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds time entry for a user. The request body should contain the necessary information to log the time entries.
     * Add time entry
     */
    async apiTimeEntriesPostRaw(requestParameters: ApiTimeEntriesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTimeEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'createTimeEntryRequest',
                'Required parameter "createTimeEntryRequest" was null or undefined when calling apiTimeEntriesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTimeEntryRequestToJSON(requestParameters['createTimeEntryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds time entry for a user. The request body should contain the necessary information to log the time entries.
     * Add time entry
     */
    async apiTimeEntriesPost(requestParameters: ApiTimeEntriesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesPostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a paginated list of time entries for a specific user. The request body should contain the user ID and optional date range for filtering the time entries.
     * Get time entries
     */
    async apiTimeEntriesScrollPostRaw(requestParameters: ApiTimeEntriesScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetTimeEntryResponse>> {
        if (requestParameters['getTimeEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'getTimeEntryRequest',
                'Required parameter "getTimeEntryRequest" was null or undefined when calling apiTimeEntriesScrollPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTimeEntryRequestToJSON(requestParameters['getTimeEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetTimeEntryResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of time entries for a specific user. The request body should contain the user ID and optional date range for filtering the time entries.
     * Get time entries
     */
    async apiTimeEntriesScrollPost(requestParameters: ApiTimeEntriesScrollPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetTimeEntryResponse> {
        const response = await this.apiTimeEntriesScrollPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an existing time entry type.
     * Delete time entry type
     */
    async apiTimeEntriesTypeIdDeleteRaw(requestParameters: ApiTimeEntriesTypeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesTypeIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an existing time entry type.
     * Delete time entry type
     */
    async apiTimeEntriesTypeIdDelete(requestParameters: ApiTimeEntriesTypeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesTypeIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update an existing time entry type.
     * Update time entry type
     */
    async apiTimeEntriesTypeIdPutRaw(requestParameters: ApiTimeEntriesTypeIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTimeEntriesTypeIdPut().'
            );
        }

        if (requestParameters['updateTimeEntryTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTimeEntryTypeRequest',
                'Required parameter "updateTimeEntryTypeRequest" was null or undefined when calling apiTimeEntriesTypeIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/type/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTimeEntryTypeRequestToJSON(requestParameters['updateTimeEntryTypeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an existing time entry type.
     * Update time entry type
     */
    async apiTimeEntriesTypeIdPut(requestParameters: ApiTimeEntriesTypeIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesTypeIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Adds a new time entry type. The request body should contain the necessary information to create the time entry type.
     * Add time entry type
     */
    async apiTimeEntriesTypePostRaw(requestParameters: ApiTimeEntriesTypePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTimeEntryTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'createTimeEntryTypeRequest',
                'Required parameter "createTimeEntryTypeRequest" was null or undefined when calling apiTimeEntriesTypePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/type`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTimeEntryTypeRequestToJSON(requestParameters['createTimeEntryTypeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a new time entry type. The request body should contain the necessary information to create the time entry type.
     * Add time entry type
     */
    async apiTimeEntriesTypePost(requestParameters: ApiTimeEntriesTypePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTimeEntriesTypePostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a list of all available time entry types.
     * Get all time entry types
     */
    async apiTimeEntriesTypesGetRaw(requestParameters: ApiTimeEntriesTypesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTimeEntryTypeResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/time-entries/types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTimeEntryTypeResponseFromJSON));
    }

    /**
     * Retrieves a list of all available time entry types.
     * Get all time entry types
     */
    async apiTimeEntriesTypesGet(requestParameters: ApiTimeEntriesTypesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTimeEntryTypeResponse>> {
        const response = await this.apiTimeEntriesTypesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
